// noinspection JSUnusedGlobalSymbols
import GoogleAds, {
  GoogleAdsId,
  GA4Id,
  CriteoPartnerID,
  FacebookId,
  BingId,
  KlaviyoId,
} from './utils/GoogleAds'

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */
import wrapWithProvider from './redux-provider'
// import NProgress from 'nprogress'

import {
  TrackEvent,
  TrackUser,
  PersonalInfo,
  CheckTrackedUser,
  SendCriteoEvent,
} from './src/helpers/TrackingHelper'
import {
  readStoredConsent,
  prefsToConsentParams,
  REGULATED_REGIONS,
  DEFAULT_SCRIPT_CONSENT,
} from './src/helpers/consentMode'
import { createThirdPartyScriptManager } from './src/helpers/thirdPartyScripts'
import { initWebVitals } from './src/helpers/webVitals'

// const initRudderStack = () => {
//   window.rudderanalytics.loadJS()
// }

const addKlaviyoFormsTracking = () => {
  if (window.__klaviyoFormsTrackingInitialized) return
  window.__klaviyoFormsTrackingInitialized = true
  window.addEventListener('klaviyoForms', function (e) {
    /* Possible values for e.detail.type:
     * Read: https://help.klaviyo.com/hc/en-us/articles/115005077027
     * ```
    if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
      gtag('event', 'form_open', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'submit') {
      gtag('event', 'form_submit', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'stepSubmit') {
      gtag('event', 'form_step_submit', {
        form: 'Klaviyo form',
        step_name: e.detail.metaData.$step_name,
      })
    }
    if (e.detail.type == 'redirectedToUrl') {
      gtag('event', 'form_url_redirect', { form: 'Klaviyo form', form_id: e.detail.formId })
    }
    if (e.detail.type == 'close') {
      gtag('event', 'form_close', { form: 'Klaviyo form', form_id: e.detail.formId })
    } ```
    */
    if (e?.detail?.type == 'submit') {
      const formId = e?.detail?.formId
      const formTitle = e?.detail?.metaData?.$source
      const email = e?.detail?.metaData?.$email
      TrackUser(email, PersonalInfo({ ...e.detail, ...e?.detail?.metaData }))
      TrackEvent(
        'email_subscribe',
        {
          email,
          source: 'Klaviyo',
          formId,
          formTitle,
        },
        {
          klaviyoEventName: 'Email Subscribe',
          googleAdsConversion: GoogleAds.Conversions.email_subscribe,
          facebook: {
            fbEvent: 'Contact',
          }
        }
      )
    }
  })
}
const getQueryString = () => {
  const item = window.sessionStorage.getItem('qs')
  if (!item) return {}
  try {
    const qs = JSON.parse(item)
    window.qs = qs
    return qs
  } catch {
    return {}
  }
}
const setQueryString = qs => {
  try {
    window.sessionStorage.setItem('qs', JSON.stringify(qs))
  } catch (e) {
    console.error('Failed to save query string to sessionStorage', e)
  }
  window.qs = qs
}
const addScriptExecutor = (doc, tag, src, onLoad) => {
  let head = doc.getElementsByTagName(tag)[0]
  let scrpt = doc.createElement(tag)
  scrpt.async = true
  scrpt.src = src
  if (onLoad) {
    scrpt.onload = scrpt.onreadystatechange = function () {
      let ready = this.readyState
      if (!ready || ready === 'loaded' || ready === 'complete') {
        onLoad()
        scrpt.onload = scrpt.onreadystatechange = null
      }
    }
  }
  head.parentNode.insertBefore(scrpt, head)
}
const addScript = (src, onLoad) => {
  addScriptExecutor(document, 'script', src, onLoad)
}
// const initGTM = (wnd, layer, id) => {
//   wnd[layer] = wnd[layer] || []
//   wnd[layer].push({
//     'gtm.start': new Date().getTime(),
//     event: 'gtm.js',
//   })
//   let dl = layer != 'dataLayer' ? '&l=' + layer : ''
//   addScript('//www.googletagmanager.com/gtm.js?id=' + id + dl)
// }

export const shouldUpdateScroll = ({ routerProps, prevRouterProps, getSavedScrollPosition }) => {
  const { location } = routerProps

  console.log('[DEBUG] Should Update Scroll?', { hash: location.hash })
  if (location.hash) return false

  if (prevRouterProps && typeof getSavedScrollPosition === 'function') {
    const pos = getSavedScrollPosition(location) || [0, 0]
    console.log('[DEBUG] Update Scroll', { pos })
    return pos 
  }

  console.log('[DEBUG] Update Scroll', { pos: [0, 0] })
  return [0, 0]
}

export const onClientEntry = () => {
  console.log('Welcome to Gray & Sons!')
  if (typeof window !== 'undefined' && !window.__backNavListener) {
    window.__backNavListener = true
    window.__isBackNav = false
    window.addEventListener('popstate', () => {
      window.__isBackNav = true
    })
  }
  window.user = window.user || {} 
  window.dataLayer = window.dataLayer || []
  window._learnq = window._learnq || []
  window.criteo_q = window.criteo_q || []
  window.oaiq = window.oaiq || function () {
    (window.oaiq.q = window.oaiq.q || []).push(arguments)
  }
  window.uetq = window.uetq || []
  function gtag() {
    window.dataLayer.push(arguments)
  }
  window.gtag = window.gtag || gtag
  initWebVitals(window)

  // let tng = window.tng = (window.tng = window.tng || [])
  window.addScript = addScript
  const fbq = (window.fbq =
    window.fbq ||
    function () {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, arguments)
      } else {
        (fbq.queue || (fbq.queue = [])).push(arguments)
      }
    })
  fbq.loaded = fbq.loaded || false
  fbq.queue = fbq.queue || []
  fbq.push = fbq
  fbq.version = '2.0'
  window._fbq = window._fbq || fbq

  let deviceType = /iPad/.test(navigator.userAgent)
    ? 't'
    : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
      ? 'm'
      : 'd'
  let initial_page = window.sessionStorage.getItem('initial_page')
  if (!initial_page) {
    window._initial_page = window.location.href
    window.sessionStorage.setItem('initial_page', window._initial_page)
  } else {
    window._initial_page = initial_page
  }
  window._device_type = deviceType

  // --- Google Consent Mode v2 ---
  const storedConsent = readStoredConsent()
  if (storedConsent) {
    // Returning visitor with confirmed prefs
    gtag('consent', 'default', prefsToConsentParams(storedConsent))
  } else {
    // New visitor — global default: grant all
    gtag('consent', 'default', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted',
    })
    // Override for regulated regions: deny all + wait for banner
    gtag('consent', 'default', {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500,
      region: REGULATED_REGIONS,
    })
  }

  gtag('js', new Date())

  const scriptConsent = storedConsent || DEFAULT_SCRIPT_CONSENT
  const scriptManager =
    window.__thirdPartyScripts ||
    createThirdPartyScriptManager({
      consent: scriptConsent,
      ids: {
        ga4: GA4Id,
        googleAds: GoogleAdsId,
        criteo: CriteoPartnerID,
        facebook: FacebookId,
        bing: BingId,
        klaviyo: KlaviyoId,
        openai: '2wSQB28K7MVRfqgFcP5G8R',
      },
      onKlaviyoLoad: addKlaviyoFormsTracking,
      onAdvertisingLoad: () => setTimeout(CheckTrackedUser, 500),
    })
  window.__thirdPartyScripts = scriptManager
  fbq.load = () => scriptManager.loadVendor('facebook')
  scriptManager.start()

  // tng.runLoad = function () {}
  // tng.load = function () {
  //   if (tng.loaded) return
  //   tng.runLoad = tng.load
  //   if (!window.scriptsDidInit) return
  //   tng.loaded = true
  //   addScript(
  //     '//cdn.tangiblee.com/integration/5.0/managed/www.grayandsons.com/revision_2/variation_original/tangiblee-bundle.min.js'
  //   )
  // }
  // window.renderBadge = function () {
  //   const el = document.getElementById('google-merchant-badge-container')
  //   if (!window.gapi || !el || el.__gmrbInit) return
  //   el.__gmrbInit = true
  //
  //   // --- CONSTANTS ---
  //   const CHIP_W = 255
  //   const CHIP_H = 68
  //
  //   // --- START: stable chip box => zero CLS, zero “dead zone” ---
  //   el.style.width = CHIP_W + 'px'
  //   el.style.height = CHIP_H + 'px'
  //   el.setAttribute('aria-hidden', 'true')
  //   el.classList.add('gmrb-collapsed', 'gmrb-clip') // collapsed: iframe not clickable, clipped to chip
  //
  //   // --- LOAD & RENDER BADGE ---
  //   window.gapi.load('ratingbadge', () => {
  //     window.gapi.ratingbadge.render(el, {
  //       merchant_id: 10751,
  //       position: 'LEFT_BOTTOM',
  //     })
  //
  //     // Wait for iframe, then reveal (opacity/transform only)
  //     const waitForIframe = () => {
  //       const f = el.querySelector('iframe')
  //       if (!f) return requestAnimationFrame(waitForIframe)
  //       el.classList.add('is-ready') // purely visual; does not change layout
  //
  //       // ResizeObserver on the iframe ONLY.
  //       // We resize host to iframe's size ONLY when expanded (post-interaction => no CLS).
  //       const ro = new ResizeObserver(() => {
  //         if (!el.classList.contains('gmrb-expanded')) return
  //         // const r = f.getBoundingClientRect()
  //         el.style.width = f.style.width //  Math.round(r.width) + 'px'
  //         el.style.height = f.style.height // Math.round(r.height) + 'px'
  //       })
  //       ro.observe(f)
  //
  //       // If Google swaps the iframe node, reobserve the new one
  //       const mo = new MutationObserver(() => {
  //         const nf = el.querySelector('iframe')
  //         if (nf && nf !== f) {
  //           ro.disconnect()
  //           ro.observe(nf)
  //         }
  //       })
  //       mo.observe(el, { childList: true })
  //
  //       // --- Expand / Collapse helpers ---
  //       const expand = () => {
  //         // allow iframe to be interactive and grow to its natural size
  //         el.classList.remove('gmrb-collapsed', 'gmrb-clip')
  //         el.classList.add('gmrb-expanded')
  //         el.setAttribute('aria-hidden', 'false')
  //
  //         // snap to current iframe size immediately
  //         const fi = el.querySelector('iframe')
  //         if (fi) {
  //           const r = fi.getBoundingClientRect()
  //           el.style.width = Math.round(r.width) + 'px'
  //           el.style.height = Math.round(r.height) + 'px'
  //         }
  //       }
  //
  //       const collapse = () => {
  //         // return to chip; no overlay above the chip height
  //         el.classList.remove('gmrb-expanded')
  //         el.classList.add('gmrb-collapsed', 'gmrb-clip')
  //         el.setAttribute('aria-hidden', 'true')
  //         el.style.width = CHIP_W + 'px'
  //         el.style.height = CHIP_H + 'px'
  //       }
  //
  //       // Interaction model:
  //       // While collapsed, the iframe doesn't receive input (pointer-events:none),
  //       // so we always catch the intent on the container reliably.
  //       el.addEventListener(
  //         'pointerdown',
  //         e => {
  //           if (el.classList.contains('gmrb-collapsed')) {
  //             expand()
  //             e.preventDefault()
  //             e.stopPropagation()
  //           }
  //         },
  //         { passive: true }
  //       )
  //
  //       // Click outside or ESC collapses back to chip
  //       document.addEventListener(
  //         'pointerdown',
  //         e => {
  //           if (!el.contains(e.target)) collapse()
  //         },
  //         { passive: true }
  //       )
  //       document.addEventListener('keydown', e => {
  //         if (e.key === 'Escape') collapse()
  //       })
  //     }
  //
  //     waitForIframe()
  //   })
  // }
}

export const onInitialClientRender = () => undefined

export const onPreRouteUpdate = () => {
  // console.log('Route Update')
  if (!window.scriptsDidInit) {
    return false
  }
  // NProgress.start()
}
// On Route Update (it can accept location and prevLocation as arguments if you need them)
export const onRouteUpdate = () => {
  // console.log('Route Done')
  // NProgress.done()
  setTimeout(() => {
    if(window.location.hash) return
    if (window.__isBackNav) {
      window.__isBackNav = false
      return
    }
    scrollTo(0, 0)
  }, 100)
  const vars = getQueryString()
  if (location.search) {
    const query = location.search.substring(1)
    query.split('&').forEach(v => {
      const pair = v.split('=')
      if (pair.length > 1) {
        vars[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
      } else {
        vars[decodeURIComponent(pair[0])] = null
      }
    })
    setQueryString(vars)
  }
  window?._learnq?.push(['track', 'Viewed a Page', { url: location.href }])
  window?._learnq?.push(['track', 'Active on Site', { url: location.href }])
  window?.gtag('event', 'page_view', {
    page_title: window.document.title,
    page_location: location.href,
  })
  window?.oaiq?.('measure', 'page_viewed', {
    type: 'contents',
    contents: [
      {
        id: location.pathname,
        name: window.document.title,
        content_type: 'page',
      }
    ]
  })
  if (location.pathname === '/') {
    window?.gtag('event', 'home_view', {
      page_title: window.document.title,
      page_location: location,
    })
    SendCriteoEvent({ event: 'viewHome' })
  } else {
    SendCriteoEvent({ event: 'viewPage' })
  }
  // window?.rudderanalytics?.page()
  // ensure badge renders after SPA navigations once the placeholder is in the DOM
  // window?.renderBadge?.()
}
export const wrapRootElement = wrapWithProvider
